module.exports = __webpack_public_path__ + "media/images/icons/outlined/dash-022cbb143c44b3844ef9069bfaa26ed4.svg";